var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1300192433(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833355 0.5C0.496307 0.5 0.192441 0.674029 0.0634584 0.940944C-0.0655244 1.20785 0.00576707 1.51508 0.244099 1.71936L4.41073 5.2908C4.73615 5.56973 5.26381 5.56973 5.58923 5.2908L9.75587 1.71936C9.99421 1.51508 10.0655 1.20785 9.93654 0.940944C9.80754 0.674029 9.50371 0.5 9.16663 0.5H0.833355Z",
    fill: "#646C6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1300192433);
export default __webpack_public_path__ + "static/media/Frame 1300192433.f05e9bb9c081b34873b41a63ae597567.svg";
export { ForwardRef as ReactComponent };